export default "__VITE_ASSET__CafW0tI2__"